"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Site = void 0;
var create_entity_1 = require("../../utils/create-entity");
var graphql_1 = require("../../utils/graphql");
var site_details_layout_1 = require("../../components/entities/site-details-layout");
var site_card_1 = require("../../components/entities/site-card");
var site_details_banner_1 = require("../../components/entities/site-details-banner");
exports.Site = {
  name: 'Site',
  label: 'Website',
  autoRoutes: ['list', 'details', 'create', 'update'],
  useCreator: true,
  useConnections: true,
  includeInSearch: true,
  // useNetwork: true,
  table: {
    fieldNames: ["thumbnail", "info", "url", "createdBy"]
  },
  connections: {
    // useGroups: true,
    // dagMode: "td",
    // linkCurvature: 0,
    // dagLevelDistance: 30,
    // cooldownTime: 3000,
    // d3VelocityDecay: 0.4,
  },
  list: {
    queryFields: (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      id\n      name\n      slug\n      path\n      url\n      owner { ...EntityValueFields }\n      deploymentUrl\n      pages { ...EntityValueFields }\n      \n    "], ["\n      id\n      name\n      slug\n      path\n      url\n      owner { ...EntityValueFields }\n      deploymentUrl\n      pages { ...EntityValueFields }\n      \n    "]))),
    banner: {
      content: "Manage the {{SITES}} content-managed via the Platform."
    },
    resultsVariant: 'grid'
  },
  details: {
    queryFields: (0, graphql_1.graphql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ...EntityValueFields\n      description { ...ContentNodeFields }\n      summary { ...ContentNodeFields }\n      twitter facebook flickr linkedin tiktok instagram youtube url\n      owner { ...EntityValueFields }\n      homePage { ...EntityValueFields }\n      knowledgeHubPage { ...EntityValueFields }\n      termsPage { ...EntityValueFields }\n      privacyPolicyPage { ...EntityValueFields }\n      contactEmail\n      supportEmail\n    "], ["\n      ...EntityValueFields\n      description { ...ContentNodeFields }\n      summary { ...ContentNodeFields }\n      twitter facebook flickr linkedin tiktok instagram youtube url\n      owner { ...EntityValueFields }\n      homePage { ...EntityValueFields }\n      knowledgeHubPage { ...EntityValueFields }\n      termsPage { ...EntityValueFields }\n      privacyPolicyPage { ...EntityValueFields }\n      contactEmail\n      supportEmail\n    "])))
  },
  banner: {
    alwaysShowIcon: true
  },
  components: {
    details: site_details_layout_1.SiteDetailsLayout,
    card: site_card_1.SiteCard,
    banner: site_details_banner_1.SiteDetailsBanner
  },
  form: {
    modal: {
      maxWidth: "1200px"
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'standard-pages'
    }, {
      name: 'logos'
    }, {
      name: 'views'
    }, {
      name: 'spotlights'
    }, {
      name: 'onboarding'
    }, {
      name: 'social'
    }, {
      name: 'header'
    }, {
      name: 'footer'
    }, {
      name: 'email'
    }, {
      name: 'gpt'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      url: {
        type: 'url'
      },
      title: {
        type: 'text',
        description: 'Specify a title for this {{SITE}}. This will be used for the browser title, and as an OpenGraph title (og:title) for social sharing.'
      },
      summary: {
        type: 'textArea',
        height: '80px',
        description: 'Specify a summary for this {{SITE}}. This will be used as the default OpenGraph summary (og:summary) for social sharing. Note: Individual pages may override this with their own summary or intro'
      },
      thumbnail: {
        type: 'image',
        description: 'Specify a thumbnail for this {{SITE}}. This will be used as the default OpenGraph thumbnail (og:thumbnail) for social sharing. Note: Individual pages may override this with their own {{IMAGE_ASSET}} or {{BANNER}}'
      },
      owner: {
        type: 'linked',
        label: 'Owner',
        entityTypeName: 'Organisation',
        fieldSet: 'overview',
        description: 'Which {{ORGANISATION}} owns this site? The name of this {{ORGANISATION}} will generally be shown next to a copyright message in the {{SITE}}.'
      },
      creator: {
        type: 'linked',
        label: "Creator ({{ORGANISATION}})",
        entityTypeName: 'Organisation',
        description: "Specify an {{ORGANISATION}} to show in the Website By: section of the footer, if applicable."
      },
      poweredBy: {
        type: 'linked',
        label: "Powered By ({{ORGANISATION}})",
        description: "Specify an {{ORGANISATION}} to show in the Powered By: section of the footer, if applicable.",
        entityTypeName: 'Organisation'
      },
      brandColors: {
        type: 'linkedMultiple',
        entityTypeName: 'Color'
      },
      views: {
        type: 'linkedTable',
        entityTypeName: 'View',
        fieldSet: 'views',
        description: 'Specify {{VIEWS}} which are used to render parts of this {{SITE}}.',
        label: 'Views'
      },
      appViews: {
        type: 'linkedTable',
        entityTypeName: 'View',
        fieldSet: 'views',
        label: "Application Views",
        description: "Specify {{VIEWS}} which are used to render the Application area of the {{SITE}}."
      },
      onboardingViews: {
        type: 'linkedTable',
        entityTypeName: 'View',
        fieldSet: 'views',
        label: "Onboarding Views",
        description: "Specify {{VIEWS}} which are used to render the Onboarding process for the {{SITE}}."
      },
      spotlights: {
        type: 'linkedTable',
        entityTypeName: 'Spotlight',
        fieldSet: 'spotlights',
        description: "Are there any spotlighted items in this {{SITE}}? Spotlighted items will typically appear higher inside listings, and the {{SPOTLIGHT_TYPE}} will be shown as a badge in UI elements."
      },
      languages: {
        type: 'linkedMultiple',
        entityTypeName: 'Language'
      },
      menus: {
        type: 'linkedMultiple',
        entityTypeName: 'Menu'
      },
      logo: {
        type: 'image',
        fieldSet: 'logos',
        description: 'Specify a logo for this {{SITE}} intended for a LIGHT background. This will typically be used as the main brand logo for the {{SITE}}.'
      },
      logoInverted: {
        type: 'image',
        label: 'Logo (Inverted)',
        isInverted: true,
        fieldSet: 'logos',
        description: 'Specify a logo for this {{SITE}} intended for a DARK background. This will typically be used as the main brand logo for the {{SITE}}.'
      },
      logoHeightMobile: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'logos',
        label: 'Logo Height (Mobile Breakpoint)',
        description: 'Enter a height for the Site logo when viewed on the mobile breakpoint, which is typically for all devices smaller than a standard tablet. If not specified, this will typically be <b>36 pixels</b> high.'
      },
      logoHeightTablet: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'logos',
        label: 'Logo Height (Tablet Breakpoint)',
        description: 'Enter a height for the Site logo when viewed on the tablet breakpoint, which is used for medium tablets and small laptops less than 1024 pixels wide. If not specified, this will typically be <b>52 pixels</b> high.'
      },
      logoHeightDesktop: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'logos',
        label: 'Logo Height (Desktop Breakpoint)',
        description: 'Enter a height for the Site logo when viewed on the desktop breakpoint, which is for any device greater than 1024 pixels wide. If not specified, this will typically be <b>66 pixels</b> high.'
      },
      logoVerticalOffset: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'logos',
        label: 'Logo Vertical Offset',
        description: 'Enter a vertical offset for the logo, where positive numbers shift the logo down slightly, negative shift it up. This may make the logo align better if it is vertically asymmetrical'
      },
      logoHorizontalOffset: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'logos',
        label: 'Logo Horizontal Offset',
        description: 'Enter a horizontal offset for the logo, where positive numbers shift the logo right slightly, negative shift it left. This may make the logo align better if it is horizontally asymmetrical'
      },
      logoVerticalOffsetMobile: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'logos',
        label: 'Logo Vertical Offset (Mobile)',
        description: 'Enter a vertical offset for the logo, for devices below 768 pixels wide'
      },
      logoHorizontalOffsetMobile: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'logos',
        label: 'Logo Horizontal Offset (Mobile)',
        description: 'Enter a horizontal offset for the logo, for devices below 768 pixels wide'
      },
      logoVerticalOffsetTablet: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'logos',
        label: 'Logo Vertical Offset (Tablet)',
        description: 'Enter a vertical offset for the logo, for devices between 768 and 1024 pixels wide'
      },
      logoHorizontalOffsetTablet: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'logos',
        label: 'Logo Horizontal Offset (Tablet)',
        description: 'Enter a horizontal offset for the logo, for devices between 768 and 1024 pixels wide'
      },
      logoVerticalOffsetDesktop: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'logos',
        label: 'Logo Vertical Offset (Desktop)',
        description: 'Enter a vertical offset for the logo, for devices greater than 1024 pixels wide'
      },
      logoHorizontalOffsetDesktop: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'logos',
        label: 'Logo Horizontal Offset (Desktop)',
        description: 'Enter a horizontal offset for the logo, for devices greater than 1024 pixels wide'
      },
      gptQuestionTemplate: {
        type: 'linked',
        entityTypeName: 'PromptTemplate',
        label: "GPT Standard Question Template",
        fieldSet: 'gpt',
        description: 'Select the template which represents a standard question for the GPT features of this {{SITE}}.'
      },
      gptLanguages: {
        type: 'linkedMultiple',
        entityTypeName: 'Language',
        label: "GPT Languages",
        fieldSet: 'gpt',
        description: "Specify the default output {{LANGUAGES}} available for all {{PROMPT_TEMPLATES}} used for GPT responses for this {{SITE}}."
      },
      deploymentUrl: {
        type: 'url',
        fieldSet: 'admin',
        description: 'Enter a Web Hook URL to invoke a build and deployment for this {{SITE}}.'
      },
      description: {
        type: 'description',
        description: 'Enter a description for this {{SITE}}. This is not typically used in the {{SITE}} itself, and is more for reference in the platform.'
      },
      twitter: {
        type: 'url',
        label: "X",
        placeholder: 'https://x.com/handle',
        fieldSet: 'social',
        description: 'What is the URL of the X profile attached to this {{SITE}}? (formerly Twitter)'
      },
      threads: {
        type: 'url',
        placeholder: 'https://www.threads.net/@handle',
        fieldSet: 'social',
        description: 'What is the URL of the Threads profile attached to this {{SITE}}?'
      },
      facebook: {
        type: 'url',
        placeholder: 'https://www.facebook.com/organisation',
        fieldSet: 'social',
        description: 'What is the URL of the Facebook profile attached to this {{SITE}}?'
      },
      linkedin: {
        type: 'url',
        placeholder: 'https://www.linkedin.com/company/012345678',
        fieldSet: 'social',
        description: 'What is the URL of the LinkedIn profile attached to this {{SITE}}?'
      },
      youtube: {
        type: 'url',
        placeholder: 'https://www.youtube.com/user/organisation',
        fieldSet: 'social',
        description: 'What is the URL of the YouTube Channel attached to this {{SITE}}?'
      },
      instagram: {
        type: 'url',
        placeholder: 'https://www.instagram.com/user',
        fieldSet: 'social',
        description: 'What is the URL of the Instagram account attached to this {{SITE}}?'
      },
      flickr: {
        type: 'text',
        placeholder: 'https://www.flickr.com/photos/012345678',
        fieldSet: 'social',
        description: 'What is the URL of the Flickr account attached to this {{SITE}}?'
      },
      tiktok: {
        type: 'text',
        placeholder: 'https://www.tiktok.com/@handle',
        fieldSet: 'social',
        description: 'What is the URL of the TikTok account attached to this {{SITE}}?'
      },
      googleSiteVerification: {
        type: 'text',
        description: 'Enter the Google site verification string, used to verify site ownership in Google\'s Search Console',
        fieldSet: 'admin'
      },
      recaptchaKey: {
        type: 'text',
        description: 'Enter your ReCAPTCHA key',
        fieldSet: 'admin'
      },
      explorerPage: {
        type: 'linked',
        label: 'Explorer {{PAGE}}',
        entityTypeName: 'Page',
        description: 'Which {{PAGE}} in the {{SITE}} is the explorer page?',
        fieldSet: 'standard-pages'
      },
      homePage: {
        type: 'linked',
        label: 'Home {{PAGE}}',
        entityTypeName: 'Page',
        description: 'Which {{PAGE}} in the {{SITE}} is the home page?',
        fieldSet: 'standard-pages'
      },
      knowledgeHubPage: {
        type: 'linked',
        label: 'Knowledge Hub {{PAGE}}',
        entityTypeName: 'Page',
        description: 'Which {{PAGE}} in the {{SITE}} is your knowledge hub page, if any?',
        fieldSet: 'standard-pages'
      },
      termsPage: {
        type: 'linked',
        label: 'Terms & Conditions {{PAGE}}',
        entityTypeName: 'Page',
        description: 'Which {{PAGE}} in the {{SITE}} shows your Terms and Conditions, if any?',
        fieldSet: 'standard-pages'
      },
      privacyPolicyPage: {
        type: 'linked',
        label: 'Privacy Policy {{PAGE}}',
        entityTypeName: 'Page',
        description: 'Which {{PAGE}} in the {{SITE}} shows your Privacy Policy?',
        fieldSet: 'standard-pages'
      },
      contactEmail: {
        type: 'email',
        fieldSet: 'email',
        description: 'Enter a contact email address for the site.'
      },
      supportEmail: {
        type: 'email',
        fieldSet: 'email',
        description: 'Enter a separate support email address, if applicable. If not specified, the contact email will be used instead.'
      },
      // featureMenu: { type: 'linked', label: 'Feature {{MENU}}', entityTypeName: 'Menu', description: 'Which {{MENU}} represents a key feature menu? These are often shown in another area in the site header, and should generally only contain one or two items', fieldSet: 'menus' },
      // secondaryMenu: { type: 'linked', label: 'Secondary {{MENU}}', entityTypeName: 'Menu', description: 'Is there another secondary {{MENU}} for this {{SITE}}?', fieldSet: 'menus' },
      mainMenu: {
        type: 'linked',
        label: 'Main {{MENU}}',
        entityTypeName: 'Menu',
        description: 'Which {{MENU}} in the {{SITE}} represents the main menu for navigation?',
        fieldSet: 'header'
      },
      linearMenu: {
        type: 'linked',
        label: 'Linear {{MENU}}',
        entityTypeName: 'Menu',
        description: 'Is there a {{MENU}} in the {{SITE}} which defines linear navigation? That is, a sequence of pages which {{SITE}} visitors can page through from start-to-finish?',
        fieldSet: 'header'
      },
      showShareMenu: {
        type: 'boolean',
        description: 'Show the Share Menu button',
        fieldSet: 'header'
      },
      showFollowMenu: {
        type: 'boolean',
        description: 'Show the Follow Menu button, to allow users to visit linked social media properties.',
        fieldSet: 'header'
      },
      showLogin: {
        type: 'boolean',
        description: 'Show a login button, which will allow users to login to the current site (this will only appear if the site has sections requiring a login).',
        fieldSet: 'header'
      },
      showPlatformLogin: {
        type: 'boolean',
        description: 'Show a login button, which will link to the URL of this platform',
        fieldSet: 'header'
      },
      loginLabel: {
        type: 'text',
        description: "What label should be shown on the login button? If not specified, this will simply be 'Login'",
        fieldSet: 'header'
      },
      platformLoginLabel: {
        type: 'text',
        description: "What label should be shown on the platform login button? If not specified, this will simply be 'Community Login'",
        fieldSet: 'header'
      },
      showContactUs: {
        type: 'boolean',
        description: "Show a Contact Us button. Clicking this will show a dropdown menu with social media properties, and a contact form",
        fieldSet: 'header'
      },
      headerButtons: {
        type: 'linkedMultiple',
        entityTypeName: 'Link',
        label: 'Additional Header Buttons',
        description: 'Specify extra {{LINKS}} to show as header buttons, next to the share, contact and login buttons.',
        fieldSet: 'header'
      },
      invitationAction: {
        type: 'text',
        description: "Specify the text to appear after 'John Smith has invited you to '. e,g. 'join the Shapeable community'",
        fieldSet: 'onboarding'
      },
      invitationByline: {
        type: 'text',
        description: "Enter a byline for the invitation email which is a short passage of text shown next to the site logo.",
        fieldSet: 'onboarding'
      },
      welcomeUrl: {
        type: 'text',
        updateArgs: 'auto: false',
        description: 'Enter the URL a user will be directed to when they click the link in the invitation email. Please only change this for testing purposes (such as when connecting to a staging server or local dev environment). By convention, it should be the {{SITE}} url, followed by /app/welcome - when you\'re done testing, please clear this field and it will assume the correct default again.',
        fieldSet: 'onboarding'
      },
      welcomeTitle: {
        type: 'text',
        description: "Enter a title for the welcome page the user arrives at when accepting an email invitation.",
        fieldSet: 'onboarding'
      },
      privacyPolicy: {
        type: 'longText',
        description: 'Enter the privacy policy text which will be displayed when a user is onboarded via this {{SITE}}.',
        fieldSet: 'onboarding'
      },
      termsAndConditions: {
        type: 'longText',
        description: 'Enter the terms and conditions text which will be also displayed when a user is onboarded via this {{SITE}}.',
        fieldSet: 'onboarding'
      },
      headerHeightMobile: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'header',
        description: 'Enter a height for the header when viewed on the mobile breakpoint, which is typically for all devices smaller than a standard tablet. If not specified, this will typically be <b>64 pixels</b>.'
      },
      headerHeightTablet: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'header',
        description: 'Enter a height for the header when viewed on the tablet breakpoint, which is used for medium tablets and small laptops less than 1024 pixels wide. If not specified, this will typically be <b>78 pixels</b>.'
      },
      headerHeightDesktop: {
        type: 'int',
        maxWidth: '100px',
        fieldSet: 'header',
        description: 'Enter a height for the header when viewed on the desktop breakpoint, which is for any device greater than 1024 pixels wide. If not specified, this will typically be <b>100 pixels</b>.'
      },
      footerContent: {
        type: 'longText',
        description: 'Provide custom content for the footer area of the site. Note you can use the text {year} to insert the current year. If not provided this text will be "© {year} {ownerName}. All rights reserved (where {ownerName} Name of the specified Site Owner)."',
        fieldSet: 'footer'
      },
      footerMenu: {
        type: 'linked',
        label: 'Footer {{MENU}}',
        entityTypeName: 'Menu',
        description: 'Which {{MENU}} in the {{SITE}} represents the footer menu for navigation?',
        fieldSet: 'footer'
      },
      footerSecondaryMenu: {
        type: 'linked',
        label: 'Footer Secondary {{MENU}}',
        description: 'Which {{MENU}} in the {{SITE}} represents the secondary menu for navigation?',
        fieldSet: 'footer'
      },
      poweredByLabel: {
        type: 'text',
        label: "Powered By Label",
        description: "Specify the text label used above the {{ORGANISATION}} selected in the Powered By field above. If not specified, this will be 'Powered By'.",
        fieldSet: 'footer'
      },
      poweredByContent: {
        type: 'longText',
        label: "Powered By Content",
        description: "Instead of the image and label above, specify the complete content which should appear in the powered by section of the footer. This is useful if you want to show custom text, instead of an {{ORGANISATION}} logo.",
        fieldSet: 'footer'
      }
    }),
    reverseFields: {
      pages: {
        type: 'linkedMultiple',
        entityTypeName: 'Page',
        source: 'sites',
        description: "Indicates which {{SITES}} will include a published page to represent this {{PAGE}} record. Conversely, {{PAGES}} which are _not_ connected to this {{SITE}} will _not_ include a page in the {{SITE}}."
      },
      people: {
        type: 'linkedMultiple',
        entityTypeName: 'Person',
        source: 'sites'
      },
      organisations: {
        type: 'linkedMultiple',
        entityTypeName: 'Organisation',
        source: 'sites'
      },
      feedEntries: {
        type: 'linkedMultiple',
        entityTypeName: 'FeedEntry',
        source: 'sites'
      },
      videos: {
        type: 'linkedMultiple',
        entityTypeName: 'Video',
        source: 'sites'
      },
      posts: {
        type: 'linkedMultiple',
        entityTypeName: 'Post',
        source: 'sites'
      },
      events: {
        type: 'linkedMultiple',
        entityTypeName: 'Event',
        source: 'sites'
      },
      economies: {
        type: 'linkedMultiple',
        entityTypeName: 'Economy',
        source: 'sites'
      }
    }
  }
};
var templateObject_1, templateObject_2;